<template>
  <div></div>
</template>

<script>
export default {
  name: "JumpPage",
  created() {
    window.location.href = "https://xinyuntongji.com";
  },
};
</script>

<style>
</style>